<template lang="pug">
div.header.mb-10
  v-app-bar
    v-card(:flat="!isToolbarDetached").flex-grow-1.d-flex.align-center.elevation-0
      v-card-title.pa-0.text-h5 Сертификация КТЗ
      //v-card-title.text-h5 {{ $t(title) }}
      //v-spacer
      //div.d-flex.flex-column.align-end
      //  span {{ user && `${ user.last_name } ${ user.first_name }`  }}
      //  small {{ user && user.username }}
      //div.ml-7
      //  v-icon(@click="out") mdi-exit-run
  v-divider
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  data () {
    return {
      isToolbarDetached: '',
      toolbarTheme: 'light',
      showSearch: false
    }
  },
  computed: {
    ...mapState({
      // user: state => state.profile.user
    }),
    title () {
      switch (this.$route.name) {
        case 'main': return 'menu.main'
        default: return 'menu.notFound'
      }
    }
  }
}
</script>
